// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"8377":"c5a5ff517d81ff7d","8400":"235b9a466bfc2ea4"}[chunkId] + ".js";
};